/**
 * getUserInfo
 *
 * @desc 描述：获取用户信息
 * @desc 描述：/system/user/getInfo
 */

/* =================================================== */

import type { RequestOptions } from '@umijs/max';
import { request } from '@umijs/max';

import type { ResStruct } from '@/services/type';

/**
 * 获取登录用户信息
 */
export function getUserInfo(op?: RequestOptions) {
  return request<ResStruct<IUserInfo>>(`/api/system/user/getInfo`, {
    method: 'get',
    ...op,
  });
}

/**
 * 根据UID获取用户详细信息
 */
export function getUidToUserDetail(params: { uid: number }, op?: RequestOptions) {
  return request<ResStruct<API.UidToUserDetailInfo>>(`/api/business/user/${params.uid}`, {
    method: 'get',
    ...op,
  });
}

/**
 * 获取用户合约或者现货或者邀请等详细信息
 */
export function getUserSelfDetail(op?: RequestOptions) {
  return request<ResStruct<API.UidToUserDetailInfo>>(`/api/business/user/self`, {
    method: 'post',
    ...op,
  });
}

export interface Params {
  '@type': string;
}

export interface Dept {
  createBy?: any;
  createTime?: any;
  updateBy?: any;
  updateTime?: any;
  remark?: any;
  params: Params;
  deptId: number;
  parentId: number;
  ancestors: string;
  deptName: string;
  orderNum: number;
  leader: string;
  phone?: any;
  email?: any;
  status: string;
  delFlag?: any;
  parentName?: any;
  children: any[];
}

export interface Roles {
  createBy?: any;
  createTime?: any;
  updateBy?: any;
  updateTime?: any;
  remark?: any;
  params: Params;
  roleId: number;
  roleName: string;
  roleKey: string;
  roleSort: number;
  dataScope: string;
  menuCheckStrictly: boolean;
  deptCheckStrictly: boolean;
  status: string;
  delFlag?: any;
  flag: boolean;
  menuIds?: any;
  deptIds?: any;
  permissions?: any;
  admin: boolean;
}

export interface User {
  createBy: string;
  createTime: string;
  updateBy?: any;
  updateTime?: any;
  remark: string;
  params: Params;
  userId: number;
  deptId: number;
  userName: string;
  nickName: string;
  email: string;
  googleAuthKey: string | null;
  googleAuthStatus: 0 | 1;
  isInitPassword: 0 | 1;
  phonenumber: string;
  sex: string;
  avatar?: any;
  password: string;
  status: string;
  delFlag: string;
  loginIp: string;
  loginDate: string;
  pwdUpdateDate: string;
  dept: Dept;
  roles: Roles[];
  roleIds?: any;
  postIds?: any;
  roleId?: any;
  admin: boolean;
  superAdmin: boolean;
}

export interface KolUser {
  bdType: string;
  exchangeProportion: number;
  futuresCommissionType: number;
  futuresProportion: number;
  id: number;
  officialEmail: string;
  returnCommission: number;
  status: string;
  teamNum: number;
  uid: number;
  userId: number;
  userName: string;
  userType: number;
}

/**
 * 用户信息
 * @desc 基于接口数据生成的
 */
export interface IUserInfo {
  // 权限
  permissions: string[];
  // 角色
  roles: string[];
  isDefaultModifyPwd: boolean;
  isPasswordExpired: boolean;
  user: User;
  kolUser?: KolUser;
}
